import React, { useEffect, useState } from 'react';
import { Container, Card, Col } from 'reactstrap'
import { Row } from 'react-bootstrap';
import DownloadButton from '../shared/IconButtons/DownloadButton';
import { getTranslation } from '../../components/Global/helpers';
import classnames from 'classnames';
import ContentPanelLayout from '../Resources/ContentPanelLayout'
import PdfContainer from '../Resources/PdfContainer';
import PrintButton from '../shared/IconButtons/PrintButton';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import HVACCertificateCoverage from './HVACCertificateCoverage';
import GenericCertificateCoverage from './GenericCertificateCoverage';
import TermsAndConditionsError from './ErrorPages/TermsAndConditionsError'

const CertificateCoverage = ({ styles, assetDetails, languageCode }) => {
    const [cocTranslation, setCocTranslation] = useState({});
    const [activeTab, setActiveTab] = useState(0);
    const [pdfLocation, setPdfLocation] = useState('doc');
    const [pdfViewLocation, setPdfViewLocation] = useState('');
    console.log(assetDetails, "COC data")
    const [certificateName, setCertificateName] = useState(assetDetails?.certificateName) 
    const [certificateTypeName, setCertificateTypeName] = useState(assetDetails?.certificateTypeName)
    let sideNavTabs = [
        { data: "certificateOfCoverage", display: "Certificate of Coverage"}        
    ]

    //show both only for non HVAC as of now for release
    if (certificateName !== "HVAC") {
        sideNavTabs = [
            { data: "certificateOfCoverage", display: "Certificate of Coverage"},
            { data: "termsAndConditions", display: "Terms and Conditions"}        
        ]
    }

    const languagePath = {
        "en-ca": "English/CA",
        "en-us": "English",
        "fr-ca": "French/CA",
        "fr-us": "French"
    }

    useEffect(() => { 
        const certName = certificateName === "HVAC" ? 'Lennox' : certificateName
        const langCode = certificateTypeName.toLowerCase() === "generic" ? "English" : languagePath[languageCode]  
        if (certName === 'Lennox') {            
            const cocContent = getTranslation(`COC/${certName}/${langCode}/components/COC.json`)
                .then(response => response.json());        
            const coverageDetail = getTranslation(`COC/Lennox/${languagePath[languageCode]}/components/CoverageType.json`)
                .then(response => response.json());
            const assetDetails = getTranslation(`COC/Lennox/${languagePath[languageCode]}/components/AssetDetails.json`)
                .then(response => response.json());
            Promise.all([cocContent, coverageDetail, assetDetails]).then(data => {
                setCocTranslation({
                    cocContent: data?.[0],
                    coverageDetail: data?.[1],
                    assetDetails: data?.[2]
                });
            })
        } else {
            const cocContent = getTranslation(`COC/${certName}/${langCode}/components/COC.json`)
                .then(response => response.json());
            const headerContent = getTranslation(`COC/BrandProvider/${certName}_style.json`)
                .then(response => response.json());
            Promise.all([cocContent, headerContent]).then(data => {
                setCocTranslation({
                    cocContent: data?.[0],
                    headerContent: data?.[1]
                });
            })
        }        
    }, [])

    useEffect(() => {
        //Convert base64 to Uint8Array to be able to view PDF on our page for Terms and Conditions tab
        if (assetDetails?.certificateId && assetDetails?.termsDocumentModel) {
            const binaryStr = atob(assetDetails?.termsDocumentModel?.documentData)
            const len = binaryStr.length
            const uint8array = new Uint8Array(len)
            for (let i=0; i < len ; i++) {
                uint8array[i] = binaryStr.charCodeAt(i)
            }
            const pdfBlob = new Blob([uint8array], { type: 'application/pdf'})
            const pdfUrl = URL.createObjectURL(pdfBlob)
            setPdfViewLocation(uint8array)
            setPdfLocation(pdfUrl)
        }
    }, [assetDetails?.certificateId])

    const getLayout = () => {
        const layoutName = Object.keys(assetDetails).length > 0 && assetDetails?.certificateTypeName
        return `${layoutName}Layout`
    }
      
    const downloadPrintTemplate = () => {
        return (
            <div className={styles.screenHeader}>
                <h2 className="h5">{"Certificate of Coverage"}</h2>
                <div className={classnames(styles.downloadHov, styles.btnDiv, "mt-n2")}>
                    <DownloadButton id="downloadPDF" onClick={() => downloadAndPrintPDF(false)} />
                    <PrintButton id="printdPDF" onClick={() => downloadAndPrintPDF(true)} />
                </div>
            </div>
        )
    }

    // This is specific to Certificate of Coverage Tab
    const downloadAndPrintPDF = (isPrint) => {
        //To handle PDF while resize(SEU-35154) and to maintain its css we are adding this properties
        const originalContent = document.getElementById("content")
        const clone = originalContent.cloneNode(true)
        clone.style.width = '1024px'
        clone.style.maxWidth = 'none'
        clone.style.position = 'absolute'
        clone.style.left = '-9999px'
        clone.style.top =  '0'
        clone.style.zoom = '100%'
        clone.style.transform = 'scale(1)'

        document.body.appendChild(clone)
        html2canvas(clone, {
            scale: 1,
            useCORS: true //allow images loaded externally
        }).then(canvas => {
            const pdf = new jsPDF("p", "mm", "a4")
            const pdfwidth = pdf.internal.pageSize.getWidth()
            const pdfheight = pdf.internal.pageSize.getHeight()
            const imgWidth = pdfwidth
            const imgHeight = (canvas.height * pdfwidth) / canvas.width
            const canvasPageHeight = (canvas.height * pdfheight) / imgHeight
            let pageCanvas, ctx, pageX, pageY, pageWidth, pageHeight
            let remainingHeight = canvas.height
            let pageIndex = 0

            while (remainingHeight > 0) {
                pageCanvas = document.createElement('canvas')
                pageCanvas.width = canvas.width
                pageCanvas.height = Math.min(canvasPageHeight, remainingHeight)
                ctx = pageCanvas.getContext('2d')
                pageX = 0
                pageY = pageIndex * canvasPageHeight
                pageWidth = canvas.width
                pageHeight = pageCanvas.height
                ctx.drawImage(canvas, pageX, pageY, pageWidth, pageHeight, 0, 0, pageWidth, pageHeight)
                const imgPageData = pageCanvas.toDataURL('image/png')
                const imgPageHeight = (pageHeight * pdfwidth) / canvas.width

                if (pageIndex > 0) {
                    pdf.addPage()
                    pdf.addImage(imgPageData, "PNG", 10, 10, pdfwidth, imgPageHeight)
                } else {
                    pdf.addImage(imgPageData, "PNG", 10, 10, pdfwidth - 20, imgPageHeight - 20)
                }
                remainingHeight -= canvasPageHeight
                pageIndex++
            }

            if (isPrint) {
                const pdfBlob = pdf.output("blob")
                const pdfUrl = URL.createObjectURL(pdfBlob)
                const printWindow = window.open(pdfUrl, "_blank")
                printWindow.print()
            } else {
                pdf.save(`${cocTranslation?.headerContent?.ProgramName_content} Coverage Details.pdf`)
            }
            document.body.removeChild(clone)
        })
    }

    return (
        <Container className={`contentWrapper ${styles.contentWrapper}`}>
            <Card className="p-3">
                <Row className={styles.layoutHeader}>
                    <h4>
                        {cocTranslation?.headerContent?.ProgramName_content && <span className="pr-2">{`${cocTranslation?.headerContent?.ProgramName_content}`}</span>}
                        Coverage Details
                    </h4>
                </Row>
                <Row className={classnames("mr-0", styles.showSm)}>
                    <Col lg="3" md="3" className={classnames(styles.sideNav, "pl-0")}>
                        <ul >
                            {sideNavTabs.map((navTab, index) => (
                                <li
                                    className={classnames(index === activeTab ? styles.activeSideTab : "")}
                                    key={index}
                                    onClick={() => setActiveTab(index)}
                                >
                                    {navTab.display}
                                </li>
                            ))}
                        </ul>
                    </Col>
                    
                    <Col md="9" className="p-4 ml-2 ml-md-0">
                        {activeTab === 0 ? 
                            <>
                                {downloadPrintTemplate()}                                    
                                <div className={`${styles[getLayout()]}`} id="content">
                                    {getLayout() === 'HVACLayout' ? 
                                        <HVACCertificateCoverage
                                            assetDetails={assetDetails}
                                            styles={styles}
                                            cocTranslation={cocTranslation}
                                        />
                                    :
                                        <GenericCertificateCoverage
                                            assetDetails={assetDetails}
                                            styles={styles}
                                            cocTranslation={cocTranslation}
                                        />
                                    }
                                </div>
                            </>
                        :
                            <>
                                <ContentPanelLayout
                                    title={"Terms and Conditions"}
                                    pdf={pdfLocation}
                                    displayPrintAndDownload
                                    isDisabled={assetDetails.versionId === 0 ? true : false}
                                >
                                    {assetDetails.versionId === 0 
                                        ? <TermsAndConditionsError
                                            styles={styles}
                                            assetDetails={assetDetails}
                                            headerContent={cocTranslation?.headerContent}
                                        />
                                        : <PdfContainer pdf={pdfViewLocation} hasScroll={true} />
                                    }
                                </ContentPanelLayout>
                            </>
                        }
                    </Col>                    
                </Row>               
            </Card>
        </Container>
    )
}

export default CertificateCoverage;
